import z from 'zod'

export const E164PhoneSchema = z.preprocess(
	(val) => {
		if (typeof val === 'number') return `+${String(val)}`
		if (typeof val === 'string') {
			const cleaned = val.replace(/[^\d+]/g, '')
			return cleaned.startsWith('+') ? cleaned : `+${cleaned.replace(/^\+?/, '')}`
		}

		return val
	},
	z
		.string()
		.regex(
			/^(\+?\d{2}\s?)?(\(?\d{2}\)?\s?)(\d{4,5}[-.\s]?\d{4})$/,
			'Telefone inválido. Use E.164, ex: +5511999999999',
		)
		.length(14),
)
